import React, { useEffect, useState } from 'react'
import { toast } from 'react-toastify'
import { Section } from '../../../components/Page'
import { Switch } from '../../../components/Inputs/Switch'
import { getUserSettings, updateUserSettings } from '../../../requests/userSettings'
import { handleError } from '../../../errors/handleError'

export const SettingsSection: React.FC = () => {
  const [userSettings, setUserSettings] = useState({
    emailNotificationsOn: true
  })

  useEffect(() => {
    const fetchUserSettings = async () => {
      try {
        const res = await getUserSettings()

        setUserSettings(res.data)
      } catch (err) {
        handleError(err, 'Failed to fetch user settings. Please try again later')
      }
    }

    fetchUserSettings()
  }, [])

  const handleChecked = async (checked: boolean) => {
    try {
      setUserSettings({ emailNotificationsOn: checked })
      await updateUserSettings({ emailNotificationsOn: checked })

      toast.success('Settings saved.')
    } catch (err) {
      handleError(err, 'Failed to update user settings. Please try again later')
    }
  }

  return (
    <Section title="Notifications">
      <Switch label="Enable Email Notifications" checked={userSettings.emailNotificationsOn} onChange={handleChecked} />
    </Section>
  )
}
